import { render, staticRenderFns } from "./RegistrationApplicationSection.vue?vue&type=template&id=47cbfb2a&scoped=true&lang=pug&"
import script from "./RegistrationApplicationSection.vue?vue&type=script&lang=js&"
export * from "./RegistrationApplicationSection.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationApplicationSection.vue?vue&type=style&index=0&id=47cbfb2a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbfb2a",
  null
  
)

export default component.exports